// @ts-nocheck

import { request } from '../../context';
import type { ApiOptions } from '../../context';
import type {
    GetPromptTasksByIdParam,
    BaseResponsePromptTaskFoundResponse,
    PutPromptTasksByIdParam,
    PutPromptTasksByIdBody,
    BaseResponseVoid,
    DeletePromptTasksByIdParam,
} from '../../types';

/**
 * findById
 *
 * @export
 * @tags prompt-task-controller
 * @link [GET] /promptTasks/{id}
 * @param id
 */
export function getPromptTasksById(
    options: ApiOptions<GetPromptTasksByIdParam, never> & { segments: GetPromptTasksByIdParam }
): Promise<BaseResponsePromptTaskFoundResponse> {
    return request<never, GetPromptTasksByIdParam, never>('/promptTasks/{id}', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getPromptTasksById',
    });
}

/**
 * update
 *
 * @export
 * @tags prompt-task-controller
 * @link [PUT] /promptTasks/{id}
 * @param id
 */
export function putPromptTasksById(
    data: PutPromptTasksByIdBody,
    options: ApiOptions<PutPromptTasksByIdParam, never> & { segments: PutPromptTasksByIdParam }
): Promise<BaseResponseVoid> {
    return request<PutPromptTasksByIdBody, PutPromptTasksByIdParam, never>('/promptTasks/{id}', {
        ...options,
        data,
        method: 'put',
        __$requestCalleeName: 'putPromptTasksById',
    });
}

/**
 * deleteById
 *
 * @export
 * @tags prompt-task-controller
 * @link [DELETE] /promptTasks/{id}
 * @param id
 */
export function deletePromptTasksById(
    options: ApiOptions<DeletePromptTasksByIdParam, never> & {
        segments: DeletePromptTasksByIdParam;
    }
): Promise<BaseResponseVoid> {
    return request<never, DeletePromptTasksByIdParam, never>('/promptTasks/{id}', {
        ...options,
        method: 'delete',
        __$requestCalleeName: 'deletePromptTasksById',
    });
}

export const meta = [
    { tags: ['prompt-task-controller'], path: '/promptTasks/{id}', method: 'get' },
    { tags: ['prompt-task-controller'], path: '/promptTasks/{id}', method: 'put' },
    { tags: ['prompt-task-controller'], path: '/promptTasks/{id}', method: 'delete' },
];
